<template>
	<section class="quit_form_look">
		<Nav title="申请退单" />
		<section class="top_img">
			<img src="../../assets/img/look_check.png" v-if="orderInfoObj.refundAuditStatus==0"/>
			<img src="../../assets/img/look_refuse.png" v-else-if="orderInfoObj.refundAuditStatus==30" />
			<img src="../../assets/img/look_success.png" v-else-if="orderInfoObj.refundAuditStatus==20" />
		</section>
		<section class="form">
			

			<section class="order_info">
				<h3>订单信息<img src="../../assets/img/quit_tit_line.png" /></h3>
				<p class="item">
					<span class="t_span">客户姓名</span>
					<span>{{orderInfoObj.name}}</span>
				</p>
				<p class="item">
					<span class="f">接单时间</span>
					<span>{{orderInfoObj.createTime}}</span>
				</p>
				<p class="item">
					<span class="t_span">支付金额</span>
					<span>{{orderInfoObj.amount}}展业币</span>
				</p>
			</section>
			<section class="quit_info">
				<h3>订单信息</h3>
				<p class="item">
					<span class="t_span">退单申请时间</span>
					<span>{{orderInfoObj.refundTime}}</span>
				</p>
				<p class="item" v-if="orderQuitInfo.refundReason">
					<span class="t_span">退单原因</span>
					<span>{{orderQuitInfo.refundReason}}</span>
				</p>
				<p class="item" v-if="refundPhotosArr.length>0">
					<span class="t_span">附件照片</span>
					<span class="cover_list">
						<img v-for="item in refundPhotosArr" :key="item" :src="item" />
					</span>
				</p>
				<p class="item" v-if="orderQuitInfo.refundDescription">
					<span class="t_span">补充描述</span>
					<span class="desc">{{orderQuitInfo.refundDescription}}</span>
				</p>

			</section>
			<section class="check_info">
				<h3>审核信息</h3>
				<p class="item">
					<span class="t_span">审核状态</span>
					<span class="audit audit1" v-if="orderInfoObj.refundAuditStatus == 0">
						<img src="../../assets/img/audit1.png">
						审核中
					</span>
					<span class="audit audit2" v-else-if="orderInfoObj.refundAuditStatus == 20">
						<img src="../../assets/img/audit3.png">
						退单成功
					</span>
					<span class="audit" v-else-if="orderInfoObj.refundAuditStatus == 30">
						<img src="../../assets/img/audit2.png">
						审核失败
					</span>
				</p>
				<p class="item">
					<span class="t_span">提示信息</span>
					<span>{{orderInfoObj.promptInformation}}</span>
				</p>
			</section>
		</section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Notify,Dialog } from 'vant';
import clienteleServer from "api/clientele";


export default {
	components: {
		Nav,
	},
	data() {
		return {
			orderInfoObj: {
				name: '',
				createTime: '',
				amount: '',
				refundAuditStatus: '',
				refundTime: '',
			},
			orderId: '',
			orderQuitInfo: {

			},
			refundPhotosArr: [],
			cover1: '',
			cover2: '',
			cover3: '',
			reasonList: [],
			activeId: '',
		}

	},
	created() {
		this.orderId = this.$route.params.id
		this.orderInfo()
		this.getReason()
		
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getReason() {
			clienteleServer.SearchReason().then((res) => {
				for(let key in res.data) {
					this.reasonList.push({
						id: key,
						name: res.data[key],
					})
				}
				this.quitInfo(res.data)
			})
		},
		
		orderInfo() {
			clienteleServer.SearchClienteleInfo({orderId: this.orderId}).then((res) => {
				this.orderInfoObj.name = res.data.require.basicInfo.name
				this.orderInfoObj.createTime = res.data.createTime
				this.orderInfoObj.amount = res.data.require.amount
				this.orderInfoObj.refundAuditStatus = res.data.refundAuditStatus
				this.orderInfoObj.promptInformation = res.data.promptInformation
				this.orderInfoObj.refundTime = res.data.refundTime
				
			})
		},
		
		quitInfo(data) {
			clienteleServer.SearchQuitInfo({orderId: this.orderId}).then((res) => {
				this.orderQuitInfo = res.data
				if(res.data.refundPhotos) {
					this.refundPhotosArr = res.data.refundPhotos.split(';')
				}
				this.refundPhotosArr= this.refundPhotosArr.filter((x) => x !== '');
				this.orderQuitInfo.refundReason = data[this.orderQuitInfo.refundReason]
			})
		}
		

	}
}
</script>

<style lang="scss">
	.quit_form_look {
		padding-top: 46px;
		.top_img {
			img {
				width: 100%;
				display: block;
			}
		}
		.form {
			padding: 0 15px;
			margin-top: -50px;
			
			h3 {
					position: relative;
					height: 54px;
					line-height: 54px;
					padding-left: 13px;
					color: #2B2F3A;
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 4px;
					background: #fff;
					img {
						position: absolute;
						bottom: 0;
						left: 0;
						width: 100%;
						height: 2Px;
					}
				}
			.order_info, .quit_info, .check_info {
				background: #fff;
				border-radius: 4px;
				margin-bottom: 15px;
				.item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 10px 13px;
					span {
						color: #2B2F3A;
						font-size: 15px;
					}
					.t_span {
						color: #7D8290;
						display: block;
						min-width: 62px;
					}
					.cover_list {
						padding-left: 21px;
					}
					.desc {
						padding-left: 21px;
					}
					.cover_list {
						display: flex;
						justify-content: space-around;
						img {
							width: 70px;
							height: 70px;
							margin-right: 10px;
							&:last-of-type {
								margin-right: 0;
							}
						}
					}

				}
			}
			.quit_info, .check_info {
				h3 {
					border: 1px solid #F6F6F6;
				}
				.item{
					.audit {
						display: flex;
						align-items: center;
						color: #FD0E2D;
						font-style: 15px;
						img {
							width: 16px;
							margin-right: 3px;
						}
					}
					.audit1 {
						color: #FF9165;
					}
					.audit2 {
						color: #37B457;
					}
				} 
				
			}
			
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/quitForm/Look.vue